import { RichTypeAny, RichTypeString } from "../../flowGraphRichTypes.js";
import { FlowGraphWithOnDoneExecutionBlock } from "../../flowGraphWithOnDoneExecutionBlock.js";
/**
 * @experimental
 */
export class FlowGraphSendCustomEventBlock extends FlowGraphWithOnDoneExecutionBlock {
    constructor() {
        super();
        this.eventId = this._registerDataInput("eventId", RichTypeString);
        this.eventData = this._registerDataInput("eventData", RichTypeAny);
    }
    _execute(context) {
        const eventId = this.eventId.getValue(context);
        const eventData = this.eventData.getValue(context);
        context.graphVariables.eventCoordinator.notifyCustomEvent(eventId, eventData);
        this.onDone._activateSignal(context);
    }
}
//# sourceMappingURL=flowGraphSendCustomEventBlock.js.map